import { GlSprintf, GlButton } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { createAlert } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/alert.js?vue3';
import { TYPE_ISSUE, TYPE_TEST_CASE, issuableTypeText } from '~/issues/constants';
import { __, sprintf } from '~/locale';
import { confidentialityQueries } from '../../queries/constants';
export default {
    name: 'SidebarConfidentialityForm',
    i18n: {
        confidentialityOnWarning: __('You are going to turn on confidentiality. Only %{context} members with %{strongStart}%{permissions}%{strongEnd} can view or be notified about this %{issuableType}.'),
        confidentialityOffWarning: __('You are going to turn off the confidentiality. This means %{strongStart}everyone%{strongEnd} will be able to see%{commentText} this %{issuableType}.')
    },
    components: {
        GlSprintf,
        GlButton
    },
    props: {
        iid: {
            type: String,
            required: true
        },
        fullPath: {
            type: String,
            required: true
        },
        confidential: {
            required: true,
            type: Boolean
        },
        issuableType: {
            required: true,
            type: String
        }
    },
    emits: [
        'close-form'
    ],
    data () {
        return {
            loading: false
        };
    },
    computed: {
        toggleButtonText () {
            if (this.loading) {
                return __('Applying');
            }
            return this.confidential ? __('Turn off') : __('Turn on');
        },
        warningMessage () {
            return this.confidential ? this.$options.i18n.confidentialityOffWarning : this.$options.i18n.confidentialityOnWarning;
        },
        isIssue () {
            return this.issuableType === TYPE_ISSUE;
        },
        isTestCase () {
            return this.issuableType === TYPE_TEST_CASE;
        },
        isIssueOrTestCase () {
            return this.isIssue || this.isTestCase;
        },
        context () {
            return this.isIssueOrTestCase ? __('project') : __('group');
        },
        workspacePath () {
            return this.isIssueOrTestCase ? {
                projectPath: this.fullPath
            } : {
                groupPath: this.fullPath
            };
        },
        permissions () {
            return this.isIssue ? __('at least the Planner role, the author, and assignees') : __('at least the Planner role');
        },
        issuableTypeText () {
            return issuableTypeText[this.issuableType];
        },
        commentText () {
            return this.isTestCase ? '' : __(' and leave a comment on');
        }
    },
    methods: {
        submitForm () {
            this.loading = true;
            this.$apollo.mutate({
                mutation: confidentialityQueries[this.issuableType].mutation,
                variables: {
                    input: {
                        ...this.workspacePath,
                        iid: this.iid,
                        confidential: !this.confidential
                    }
                }
            }).then(({ data: { issuableSetConfidential: { errors } } })=>{
                if (errors.length) {
                    createAlert({
                        message: errors[0]
                    });
                } else {
                    this.$emit('close-form');
                }
            }).catch(()=>{
                createAlert({
                    message: sprintf(__('Something went wrong while setting %{issuableType} confidentiality.'), {
                        issuableType: this.issuableTypeText
                    })
                });
            }).finally(()=>{
                this.loading = false;
            });
        }
    }
};
